import { useMemo } from 'react';
import { checkExperimentMembership } from 'services/environment';

const useExperiment = ({ id, percentage }) =>
  useMemo(() => checkExperimentMembership(id, percentage), []);

export default useExperiment;
